import Vue from 'vue'
import Router from 'vue-router'
import NotFoundView from './components/404.vue'
import ShopView from './components/Shop.vue'
import HomeView from './components/Home.vue'
Vue.use(Router)

// Routes
const routes = [
  {
    path: '/',
    name: 'App',
    component: HomeView
  }, {
    path: '/shop',
    component: ShopView
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js